import PlatformActions from './PlatformActions'

export default class PLAYNGOSLOTActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'PLAYNGO',
      gameType: 'SLOT',
      gameCode: 'PLAYNGO-SLOT-154',
    }

    this.gameName = 'Tome of Madness'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `PnG007-${roundId}_PnG007-50000${wagerId}`, // PnG007-2109690_PnG007-500002964499
      roundId: `PnG007-${roundId}`, // PnG007-2109690
      betType: null,
      currency,
      betTime, // 2025-11-17T18:19:52.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        betType: '1',
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      isEndRound = true,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `PnG007-${roundId}_PnG007-50000${wagerId}`,
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime,
      roundId: `PnG007-${roundId}`,
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betType: '1',
        isEndRound: `${isEndRound}`,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `PnG007-${roundId}_PnG007-50000${wagerId}`,
      roundId: `PnG007-${roundId}`,
      gameInfo: {
        betType: '1',
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
